import { observer } from 'mobx-react-lite'
// evertel
import { Links } from '@evertel/constants'
import { Icon, FloatingMenu, MenuItem } from '@evertel/web/ui'

interface HeaderHelpDropdownProps {
    className?: string | undefined
    openHelpModal: () => void
}


const HeaderHelpDropdown: React.FC<HeaderHelpDropdownProps> = observer(({
    className,
    openHelpModal
}) => {

    return (
        <FloatingMenu
            id="header-dropdown-help-menu"
            label="Help Menu"
            title="Help Menu"
            aria-label="Help Menu"
            renderLabel={() => (
                <Icon
                    className="d-block"
                    name="question-circle"
                    color="primary"
                    size={16}
                    style={{width: 20, textAlign: 'center'}}
                />
            )}
            className={className}
        >
            <MenuItem
                label="Help Center"
                icon={{ name: 'life-ring' }}
                href={Links.helpCenter}
            />
            <MenuItem
                label="Contact Technical Support"
                icon={{ name: 'message-question' }}
                onClick={() => openHelpModal()}
            />
        </FloatingMenu>
    )
})

export { HeaderHelpDropdown }
